import request from '../utils/request'



export const addContact = async (data) => {
  return request({
    url: "/contact/add",
    method: 'post',
    data: {
      contactName: data.contactName,
      contactNumber: data.contactNumber,
      contactEmail: data.contactEmail,
      workPlace: data.workPlace,
      contactRemark: data.contactRemark
    }
  });
}